const _excluded = ["padding"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { Button, Card, Typography } from 'seagull';
import styles from "./IntegrationCard.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function IntegrationCard(props) {
  const {
    'data-testid': testid,
    icon,
    title,
    subTitle,
    mainAction,
    disclaimer
  } = props;
  return /*#__PURE__*/_jsxs(Card, {
    "data-testid": testid,
    className: styles.card,
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12
      },
      children: [/*#__PURE__*/_jsx("div", {
        children: icon
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Typography, {
          weight: "normal",
          children: title
        }), /*#__PURE__*/_jsx(Typography, {
          "data-testid": "".concat(testid, "-sub-title"),
          variant: 'paragraph2',
          skin: "secondary",
          children: subTitle
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.bottom,
      children: [mainAction, /*#__PURE__*/_jsx(Typography, {
        variant: 'paragraph3',
        skin: "secondary",
        children: disclaimer || ' '
      })]
    })]
  });
}
IntegrationCard.LogoImg = _ref => {
  let {
      padding
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("img", _objectSpread({
    style: {
      height: 40,
      padding
    }
  }, rest));
};
IntegrationCard.MainActionButton = props => /*#__PURE__*/_jsx(Button, _objectSpread({
  size: "small"
}, props));